import api from './index'

const resource = 'science_fields'

export default {
  getScienceFields () {
    return api.get(`${resource}`)
  }
}
